import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const post = async (data) => {
  return await httpClient.post(`/projects/`, data);
};

const counters = async () => {
  return await httpClient.get('/projects/counters');
};

const get = async (id) => {
  return await httpClient.get(`/projects/${id}/`);
};

const info = async () => {
  return await httpClient.get('projects/info/');
};

const put = async (id, data) => {
  return await httpClient.put(`/projects/${id}/`, data);
};

const patch = async (id, data) => {
  return await httpClient.put(`/projects/${id}/`, data);
};

const remove = async (id) => {
  return await httpClient.delete(`/projects/${id}`);
};

const chanteState = async (id, data) => {
  return await httpClient.patch(`/projects/${id}/change_state/`, data);
};

const ajaxTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;

  if (exportCSV)
    return await httpClient.get(
      `/projects/export` + `${query}&sort=${sortBy}` + `${searchBy}`,
      {
        responseType: 'blob',
      },
    );
  else
    return await httpClient.get(
      `/projects` +
        `${query}&page[number]=${page}&page[size]=${pageSize}` +
        `&sort=${sortBy}` +
        `${searchBy}`,
    );
};

const getTemplates = async (project_id, params) => {
  return await httpClient.get(
    `/project_templates/${project_id}/`,
    makeFilterParams(params),
  );
};

const setTemplates = async (project_id, values) => {
  return await httpClient.patch(
    `/project_templates/${project_id}/set_templates/`,
    values,
  );
};

const getName = async (id) => await httpClient.get(`/project_name/${id}`);

export {
  post,
  get,
  info,
  put,
  patch,
  remove,
  ajaxTable,
  chanteState,
  getName,
  counters,
  getTemplates,
  setTemplates,
};
